export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11083.63349e7c.jpg";